import debounce from "lodash/debounce";
import React from "react";
import { SearchWrapperArgsType } from "./type";
import { DEBOUNCE_TIME } from "shared/utils/constants";

export default function useSearchWrapperService(props: SearchWrapperArgsType) {
  const searchRef = React.useRef<any>();
  const [searchText, setSearchText] = React.useState<string>(props.appliedSearchText || "");
  const [collapseSearchBox, setCollapseSearchBox] = React.useState<boolean>(true);

  React.useEffect(() => {
    props.focusOnRender && searchRef.current?.focus();
  }, [props.focusOnRender]);

  const debouncedSearch = React.useMemo(
    () =>
      debounce(value => {
        props.searchChangeHandler(value);
      }, DEBOUNCE_TIME),
    [props]
  );

  const changeHandler = React.useCallback(
    e => {
      const value = e.target?.value;
      setSearchText(value);
      debouncedSearch(value);
    },
    [debouncedSearch]
  );

  const resetSearchText = React.useCallback(() => {
    setSearchText("");
    debouncedSearch.cancel();
    setCollapseSearchBox(true);
    props.searchChangeHandler("");
    searchRef.current?.focus();
  }, [debouncedSearch, props]);

  React.useEffect(() => {
    const isFocused = searchRef.current === document.activeElement;
    if (!isFocused) {
      setSearchText(props.appliedSearchText || "");
    }
  }, [props.appliedSearchText]);

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  return {
    changeHandler,
    searchText,
    searchRef,
    resetSearchText,
    collapseSearchBox,
    setCollapseSearchBox
  };
}
